import { BaseApiService, API_CONFIG } from './base.service';

/**
 * Service for health checks and system status
 */
export class HealthService extends BaseApiService {
  async healthCheck(): Promise<{ status: string }> {
    return this.get(API_CONFIG.ENDPOINTS.HEALTH);
  }

  async deleteWithData<T, D = any>(url: string, data?: D): Promise<T> {
    const response = await this.api.delete(url, { data });
    return response.data;
  }
}

export const healthService = new HealthService();